(function () {
    'use strict';
    app.controller('adminLandingController', ['$scope', '$location', '$cookies', '$route', function ($scope, $location, $cookies, $route) {
        if ($cookies.get('TokenInfo') == undefined || localStorage.getItem('appInfo') == undefined || getLocalValue('userRole') != 'SAdmin') {
            $location.path('/login');
            return;
        }
    }]);
})();